var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchoolPlaning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.072,
    height: 109.543,
    viewBox: "0 0 109.072 109.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.5 0.539)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3498",
    "data-name": "Rectangle 3498",
    width: 16.214,
    height: 26.427,
    transform: "translate(45.929 82.077)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5034",
    "data-name": "Path 5034",
    d: "M88.457,14.889,56.036,1.92,23.614,14.889V34.774H2v75.65H39.825V78H72.246v32.421h37.825V34.774H88.457ZM29.018,88.81H18.211V78H29.018Zm0-21.614H18.211V56.388H29.018Zm21.614,0H39.825V56.388H50.632Zm0-43.229H61.439V45.581H50.632ZM72.246,67.2H61.439V56.388H72.246ZM93.861,88.81H83.054V78H93.861Zm0-32.421V67.2H83.054V56.388Z",
    transform: "translate(-2 -1.92)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolPlaning);
export default __webpack_public_path__ + "static/media/school_planing.41b41167dfc92b729165cba5f572c39f.svg";
export { ForwardRef as ReactComponent };